// @flow
import React from 'react';
import { fill } from 'lodash';
import Grid from 'Components/frameworks/grid/Grid.jsx';
import ratioUtils from 'Components/utils/ratios/ratios.utils';

const ratio = ratioUtils.values.XL;

export const SearchResultsPlaceholder = ({ nbItems }: { nbItems: number }) => (
  <Grid>
    {fill(Array(nbItems)).map((a, i) => (
      <article
        key={i}
        className="relative flex flex-col bg-white"
        data-testid="search-results-placeholder-item"
      >
        <div className="bg-gray-lighter" style={{ paddingBottom: `${100 * ratio}%` }} />
        <div className="relative bg-white">
          <div className="flex items-stretch w-full no-underline text-inherit">
            <div className="flex-col flex-1 overflow-hidden py-1">
              <div
                className="bg-gray-lighter mb-1 flex w-3/5 mt-1 mb-2 w-4/5"
                style={{ height: '0.6rem' }}
              />
              <div className="bg-gray-lighter mb-1 flex w-3/5" style={{ height: '0.6rem' }} />
            </div>
          </div>
        </div>
      </article>
    ))}
  </Grid>
);
